export default {"wrapperContainer":"rbLWZ","back":"sCLqo","categoryGrid":"ADUBu","wrapperMainCatalogue":"GJdES","desktopGrid":"-ae6Q"};